import {
  Accordion,
  Alert,
  createStyles,
  Grid,
  Group,
  Text,
  Title,
  useMantineTheme
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconAlertCircle, IconBackpack } from '@tabler/icons'
import React from 'react'

import { PageCard } from '@/components/surfaces'
import { Channel as ChannelType, Segment as SegmentType, Store as StoreType } from '@/types'

interface Props {
  data: SegmentType
  channel: ChannelType
}

const useStyles = createStyles(theme => ({
  segment: {
    boxShadow: theme.shadows.xs,
    '&[data-active]': {
      border: 'none',
      borderColor: 'none'
    },
    button: {
      [theme.fn.smallerThan('xs')]: { padding: theme.spacing.xs / 2 }
    }
  }
}))

export default function Segment({ data, channel }: Props) {
  // Hooks
  const { classes } = useStyles()
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)
  const expandedAccordion =
    !channel?.gradesSelectionComponent || channel?.gradesSelectionComponent === 'accordion-expanded'

  return (
    !!data && (
      <Accordion
        variant="separated"
        defaultValue={expandedAccordion ? data?.displayName : null}
        mb="xs">
        <Accordion.Item value={data?.displayName} className={classes.segment}>
          <Accordion.Control>
            <Group spacing="xs">
              {!isXs && <IconBackpack size={20} />}
              <Title order={!isXs ? 4 : 6}>{data?.displayName}</Title>
            </Group>
          </Accordion.Control>
          <Accordion.Panel>
            {!data?.stores?.length && (
              <Alert icon={<IconAlertCircle size={16} />} color="orange" mb="md">
                <Text>Não encontramos nenhuma loja para ser listada aqui.</Text>
              </Alert>
            )}
            <Grid gutter="lg">
              {data?.stores?.map((store: StoreType) => (
                <Grid.Col key={store?.uid} span={12} xs={6} md={4} lg={3}>
                  <PageCard
                    image={store?.image}
                    title={store?.displayName}
                    detail={`${store?.showcases?.length}${' '}
                          ${
                            store?.showcases && store?.showcases?.length > 1
                              ? 'vitrines'
                              : 'vitrine'
                          }`}
                    slug={
                      store.showcases?.length === 1
                        ? `${store.slug}/${store.showcases[0]?.slug}`
                        : `${store?.slug}`
                    }
                  />
                </Grid.Col>
              ))}
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    )
  )
}
